<template>
  <div>
    <MenuItem
      v-if="list"
      data-qa="offer-different-price"
      icon="price-comment"
      :label="$t('Tenders.OfferDifferentPrice')"
      @click="open"/>
    <sButton
      v-else
      color="var(--white-color)"
      data-qa="offer-different-price"
      icon="price-comment"
      type="text"
      @click="open">
      {{ $t('Tenders.OfferDifferentPrice') }}
    </sButton>
    <OfferDifferentPriceDialog
      :dialog.sync="dialog"
      :element="elements[0]"
      :get-new-price="getNewPrice"
      :is-sale="isSale"
      :tender="tender"
      :validate-input="validateInput"
      @close="close"/>
    <MultipleOfferDifferentPrice
      ref="multiple"
      :dialog.sync="multiple"
      :elements="elements"
      :get-new-price="getNewPrice"
      :is-sale="isSale"
      :tender="tender"
      :validate-input="validateInput"
      @close="close"/>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import OfferDifferentPriceDialog from 'components/tenders/tender page/offer different price/OfferDifferentPriceDialog.vue'
import MultipleOfferDifferentPrice from 'components/tenders/tender page/offer different price/MultipleOfferDifferentPrice.vue'

import { offerDifferentPriceMixin } from 'mixins'

export default {
  name: 'offerDifferentPrice',
  mixins: [ offerDifferentPriceMixin ],
  data() {
    return {
      dialog: false,
      multiple: false,
    }
  },
  props: {
    tender: Object,
    elements: Array,
    list: {
      type: Boolean
    },
  },
  computed: {
    isSale() {
      return this.tender?.biddingType?.isSale
    }
  },
  methods: {
    open() {
      setTimeout(() => {
        if ( this.elements?.length == 1 ) {
          this.dialog = true
        } else {
          this.multiple = true
          this.$refs.multiple.setItems()
        }
      }, 100)
    },
    close() {
      this.$emit('callback')
      if ( this.elements?.length == 1 ) {
        this.dialog = false
      } else {
        this.multiple = false
      }
      this.$notice.closeAll()
    },
  },
  components: {
    MenuItem,
    OfferDifferentPriceDialog,
    MultipleOfferDifferentPrice
  }
}
</script>
